import { createContext, type Context } from 'react';

type Value = { keys: readonly string[] } | undefined;
export const OnboardingPersonalizationContext: Context<Value> = createContext<Value>(undefined);
